import React from "react";
import styled from "styled-components";
import Substitution from "./DFBTypes/Sub";
import KickOff from "./DFBTypes/KickOff";
import Goal from "./DFBTypes/Goal";
import Card from "./DFBTypes/Card";
const Main = styled.div`
  border-radius: 4px;
  background-color: #202731;
  height: 78%;
  min-width: 188px;
  margin: 0.2em;
  cursor: pointer;
  box-sizing: border-box;
  padding: 6px;
  display: flex;
  opacity: ${(props) => (props.faded ? "0.4" : "1")};
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  :hover {
    background-color: #0adb93;
    color: #000;
  }
  border: ${(props) =>
    props.used
      ? "1px solid #1f7f6f"
      : props.preview
        ? "1px solid #dbae0a"
        : ""};
`;
const TeamColour = styled.div`
  height: 100%;
  width: 3px;
  border-radius: 4px;
  background-color: rgb(0, 255, 252);
`;
const Content = styled.div`
  padding: 0.2em;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export default function DFBEvent({
  matchEvent,
  previewGraphic,
  game,
  index,
  events,
  teams,
  timelineGraphicsStatus,
}) {
  let player = game?.lineup?.home?.find(
    (p) => p.squad?.player?.dfb_ID === matchEvent.playerId,
  );
  if (!player) {
    player = game?.lineup?.away?.find(
      (p) => p.squad?.player?.dfb_ID === matchEvent.playerId,
    );
  }
  let team =
    game?.home_team?.dfb_ID === matchEvent.contestantId
      ? game?.home_team
      : game?.away_team;

  let kit =
    game?.home_team?.dfb_ID === matchEvent.contestantId
      ? game.home_team?.variables?.[game?.home_team_kit + "_kit_bg"] ||
        "transparent"
      : game.away_team?.variables?.[game?.away_team_kit + "_kit_bg"] ||
        "transparent";

  matchEvent = {
    ...matchEvent,
    game_time:
      matchEvent?.timeMin?.toString()?.padStart(2, "0") +
      ":" +
      matchEvent?.timeSec?.toString()?.padEnd(2, "0"),
  };

  return (
    <Main
      faded={index !== 0}
      used={
        timelineGraphicsStatus?.find(
          (tl) => tl.id === game?._id + "-" + matchEvent.id,
        )?.status === "animated"
      }
      preview={
        timelineGraphicsStatus?.find(
          (tl) => tl.id === game?._id + "-" + matchEvent.id,
        )?.status === "preview"
      }
    >
      <TeamColour
        style={{
          backgroundColor: kit || "transparent",
        }}
      />

      <Content>
        {/* {matchEvent.id} */}
        {matchEvent.type === "Substitution" && (
          <Substitution
            item={matchEvent}
            previewGraphic={previewGraphic}
            player={player}
            team={team}
            game={game}
          />
        )}
        {matchEvent.type === "KickOff" && (
          <KickOff
            item={matchEvent}
            previewGraphic={previewGraphic}
            game={game}
          />
        )}
        {matchEvent.type === "Goal" && (
          <Goal
            item={matchEvent}
            previewGraphic={previewGraphic}
            game={game}
            player={player}
            team={team}
          />
        )}
        {matchEvent.type === "Card" && (
          <Card
            item={matchEvent}
            previewGraphic={previewGraphic}
            game={game}
            player={player}
            team={team}
          />
        )}
      </Content>
    </Main>
  );
}
